export default __webpack_public_path__ + "static/media/nodejs-icon-svgrepo-com.e7e71853.svg";